import { render, staticRenderFns } from "./livestream-order.vue?vue&type=template&id=ab2681d8&"
import script from "./livestream-order.vue?vue&type=script&lang=js&"
export * from "./livestream-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports